function downloadFile(url) {
    if (!url) return
    const a = document.createElement('a')
    a.href = url
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

export {
    downloadFile,
}
